// @flow
import { useSelector, useDispatch } from "react-redux";
import { dismissNotification, showNotification } from "../redux/actions";

import type {
  DismissNotificationAction,
  NotificationState,
  ShowNotificationAction,
} from "../redux/types";

import { NOTIFICATION_TYPES } from "../constants";

import type { MessageObject } from "../i18n";
import type ErrorResponse from "../models/error/ErrorResponse";
type NotificationHook = {
  ...NotificationState,
  dismiss: () => DismissNotificationAction,
};
type ErrorNotificationHook = (
  message: MessageObject,
  error?: ?ErrorResponse,
) => ShowNotificationAction;

/**
 */
export const useNotification = (): NotificationHook => {
  const dispatch = useDispatch();
  const { render, messageType, message, error } = useSelector(
    (state) => state.notification,
  );

  return {
    render,
    messageType,
    message,
    error,
    dismiss: () => dispatch(dismissNotification()),
  };
};

/**
 */
export const useErrorNotification = (): ErrorNotificationHook => {
  const dispatch = useDispatch();
  return (message: MessageObject, error?: ?ErrorResponse) => {
    return dispatch(showNotification(NOTIFICATION_TYPES.ERROR, message, error));
  };
};
